import { render, staticRenderFns } from "./loadMore.vue?vue&type=template&id=ac1270f2"
import script from "./loadMore.vue?vue&type=script&lang=js"
export * from "./loadMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Skeleton: require('/vercel/path0/components/ui/skeleton.vue').default})
